/* Copyright (c) 2018-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { HttpClient } from '@angular/common/http';

import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of, throwError } from 'rxjs';
import { LoggingService, Logger } from '../logging/logging.service';

export class FallbackTranslationLoader implements TranslateLoader {
    private logger: Logger;
    private config: FallbackTranslationLoaderConfig = {};

    constructor(
        private http: HttpClient,
        loggingService: LoggingService,
        localeFileHashes: LocaleFileHashes,
        public prefix: string = 'assets/i18n/',
        public suffix: string = '.json'
    ) {
        this.logger = loggingService.getLogger('FallbackTranslationLoader');
        this.config.localeFileHashes = localeFileHashes;
    }

    public getTranslation(lang: string): Observable<Object> {
        let filePath: string;
        if (this.config.localeFileHashes && this.config.localeFileHashes[lang]) {
            filePath = `${this.prefix}${lang}.${this.config.localeFileHashes[lang]}${this.suffix}`;
        } else {
            filePath = `${this.prefix}${lang}${this.suffix}`;
        }

        return this.http.get(filePath);
    }
}

export interface LocaleFileHashes {
    [key: string]: string;
}

interface FallbackTranslationLoaderConfig {
    localeFileHashes?: LocaleFileHashes;
}
